<script>
	import { currentUser } from '../../utils/stores.js';
	import { fetchUsers } from '../../utils/api.js';
	import { fade } from 'svelte/transition';
	import { Loaders, TableView } from '@shopboxai/sb-portal-components';
	import UserAccessBadge from './UserAccessBadge.svelte';
	import UserAccessUpdate from './UserAccessUpdate.svelte';
	import UserAccessDelete from './UserAccessDelete.svelte';
	import UserAccessInvite from './UserAccessInvite.svelte';

	const _fetchUsers = async () => {
		let rows = [];
		const users = await fetchUsers();
		rows = users.map((user) => {
			delete user.permissions.config;
			delete user.permissions.billing;

			for (const feature in $currentUser.clientFeatures) {
				if ($currentUser.clientFeatures[feature] == false) {
					if (feature == 'open_api') {
						delete user.permissions['api_keys'];
					}
					delete user.permissions[feature];
				}
			}

			return {
				email: user.email,
				permissions: user.permissions,
				user_id: user.id,
				shopbox_admin: user.shopbox_admin
			};
		});
		return rows;
	};
	let runFetchUsers = _fetchUsers();

	const handleComplete = async () => {
		runFetchUsers = _fetchUsers();
	};
	let visible = false;
</script>

<UserAccessInvite on:complete={handleComplete} bind:visible />

{#await runFetchUsers}
	<Loaders items={[{ size: 20, height: '150px' }]} />
{:then rows}
	<TableView
		tableName="Users & Access"
		tableActionName="Invite new user"
		on:tableAction={() => (visible = true)}
	>
		<tbody slot="tbody">
			{#each rows as row}
				<tr in:fade>
					{#if $currentUser.isShopBoxAdmin == true}
						<td> {row.email}</td>
						<td> <UserAccessBadge {row} /></td>
						<td class="right">
							<UserAccessUpdate
								data={{
									permissions: row.permissions,
									user_id: row.user_id,
									email: row.email
								}}
								on:complete={handleComplete}
							/>
							<UserAccessDelete
								data={{ email: row.email, user_id: row.user_id }}
								on:complete={handleComplete}
							/>
						</td>
					{:else if row.shopbox_admin == false}
						<td> {row.email}</td>
						<td> <UserAccessBadge {row} /></td>
						<td class="right">
							<UserAccessUpdate
								data={{
									permissions: row.permissions,
									user_id: row.user_id,
									email: row.email
								}}
								on:complete={handleComplete}
							/>
							<UserAccessDelete
								data={{ email: row.email, user_id: row.user_id }}
								on:complete={handleComplete}
							/>
						</td>
					{/if}
				</tr>
			{/each}
		</tbody>
	</TableView>
{:catch}
	<h3>No users</h3>
{/await}
